const CHCheckmark = () => {
	return (
		<>
			<path
				d="M10.26 13.14C14.45 6.26002 21.38 9.39002 21.91 17.03C22.69 28.41 0.249996 29.56 10.26 13.14Z"
				fill="#F7D9D8"
			/>
			<path
				d="M13.95 22.95C13.42 22.95 13 22.52 12.34 21.83C11.48 20.94 10.19 19.59 8.79 19.06C8.27 18.86 8.01 18.29 8.21 17.77C8.41 17.25 8.98 16.99 9.5 17.19C11.12 17.81 12.53 19.15 13.47 20.12C14.95 15.51 19.07 10.44 22.64 9.07C23.15 8.87 23.73 9.13 23.93 9.65C24.13 10.17 23.87 10.74 23.35 10.94C20.33 12.1 15.89 17.46 15.02 22.06L14.91 22.66L14.28 22.91C14.16 22.95 14.05 22.96 13.95 22.96V22.95Z"
				fill="#C68486"
			/>
			<path
				d="M16 29C8.83 29 3 23.17 3 16C3 8.83 8.83 3 16 3C23.17 3 29 8.83 29 16C29 23.17 23.17 29 16 29ZM16 4C9.38 4 4 9.38 4 16C4 22.62 9.38 28 16 28C22.62 28 28 22.62 28 16C28 9.38 22.62 4 16 4Z"
				fill="#C68486"
			/>
		</>
	);
};

export default CHCheckmark;
